import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  Label,
  Button,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { get } from "../../helpers/api_helper";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import * as api from "../../constants/api_constants";
import { showErrorToast } from "../../helpers/toastMessages";
import Footer from "components/VerticalLayout/Footer";

function ViewCertificate() {
  const navigate = useNavigate();
  const { certificateId } = useParams();
  console.log("Certificate ID:", certificateId);

  const [fetchedCertificate, setFetchedCertificate] = useState({
    certificateType: "",
    recipientName: "",
    courseType: "",
    startDate: "",
    endDate: "",
    duration: "",
    email: "",
    mobileNumber: "",
    dept: "",
    hackathonName: "",
    teamName: "",
    courseName: "",
    issueDate: "",
  });

  useEffect(() => {
    if (certificateId) {
      fetchCertificateData();
    }
  }, [certificateId]);

  const fetchCertificateData = async () => {
    try {
      const response = await get(api.GET_CERTIFICATE_BY_ID(certificateId));
      const certData = response?.data;
      if (certData) {
        const updatedData = {
          certificateType: certData.certificateType?.toLowerCase() || "",
          recipientName: certData.internName || certData.emp_name || "",
          courseType: certData.courseType || "",
          startDate: certData.startDate?.slice(0, 10) || "",
          endDate: certData.endDate?.slice(0, 10) || "",
          duration: certData.duration || "",
          email: certData.email || "",
          mobileNumber: certData.mobileNumber || "",
          dept: certData.department || "",
          hackathonName: certData.hackathonName || "",
          teamName: certData.teamName || "",
          courseName: certData.courseName || certData.trainingProgramName || "",
          issueDate: certData.issuedDate?.slice(0, 10) || "",
        };
        console.log("Fetched certificate data:", updatedData);
        setFetchedCertificate(updatedData);
      }
    } catch (error) {
      console.error("Error fetching certificate data:", error);
      showErrorToast("Failed to fetch certificate data");
    }
  };

  const renderSharedFields = () => (
    <>
      <Col md={4} className="mb-3">
        <Label htmlFor="recipientName" className="col-form-label">
          Recipient Name
        </Label>
        <Input
          id="recipientName"
          type="text"
          className="form-control"
          value={fetchedCertificate.recipientName}
          disabled
        />
      </Col>
      <Col md={4} className="mb-3">
        <Label htmlFor="email" className="col-form-label">
          Email
        </Label>
        <Input
          id="email"
          type="email"
          className="form-control"
          value={fetchedCertificate.email}
          disabled
        />
      </Col>
      <Col md={4} className="mb-3">
        <Label htmlFor="mobileNumber" className="col-form-label">
          Mobile Number
        </Label>
        <Input
          id="mobileNumber"
          className="form-control"
          value={fetchedCertificate.mobileNumber}
          disabled
        />
      </Col>
      <Col md={4} className="mb-3">
        <Label htmlFor="issueDate" className="col-form-label">
          Issue Date
        </Label>
        <Input
          id="issueDate"
          type="date"
          className="form-control"
          value={fetchedCertificate.issueDate}
          disabled
        />
      </Col>
    </>
  );

  const renderInternshipFields = () => {
    console.log("Rendering Internship fields");
    const fieldMeta = [
      { key: "courseType", label: "Course Type" },
      { key: "startDate", label: "Start Date", type: "date" },
      { key: "endDate", label: "End Date", type: "date" },
      { key: "duration", label: "Duration (days)", type: "number" },
    ];

    return fieldMeta.map(({ key, label, type }) => (
      <Col md={4} key={key} className="mb-3">
        <Label htmlFor={key} className="col-form-label">
          {label}
        </Label>
        <Input
          id={key}
          type={type || "text"}
          className="form-control"
          value={fetchedCertificate[key]}
          disabled
        />
      </Col>
    ));
  };

  const renderAppreciationAchievementFields = () => {
    console.log("Rendering Appreciation/Achievement fields");
    return (
      <Col md={4} className="mb-3">
        <Label htmlFor="dept" className="col-form-label">
          Department
        </Label>
        <Input
          id="dept"
          type="text"
          className="form-control"
          value={fetchedCertificate.dept}
          disabled
        />
      </Col>
    );
  };

  const renderHackathonFields = () => {
    console.log("Rendering Hackathon fields");
    return (
      <Col md={4} className="mb-3">
        <Label htmlFor="hackathonName" className="col-form-label">
          Hackathon Name
        </Label>
        <Input
          id="hackathonName"
          type="text"
          className="form-control"
          value={fetchedCertificate.hackathonName}
          disabled
        />
      </Col>
    );
  };

  const renderBestTeamFields = () => {
    console.log("Rendering Best Team fields");
    return (
      <Col md={4} className="mb-3">
        <Label htmlFor="teamName" className="col-form-label">
          Team Name
        </Label>
        <Input
          id="teamName"
          type="text"
          className="form-control"
          value={fetchedCertificate.teamName}
          disabled
        />
      </Col>
    );
  };

  const renderCourseTrainingFields = () => {
    console.log("Rendering Course/Training fields");
    return (
      <>
        <Col md={4} className="mb-3">
          <Label htmlFor="courseName" className="col-form-label">
            {fetchedCertificate.certificateType === "course_completion"
              ? "Course Name"
              : "Training Program Name"}
          </Label>
          <Input
            id="courseName"
            type="text"
            className="form-control"
            value={fetchedCertificate.courseName}
            disabled
          />
        </Col>
        <Col md={4} className="mb-3">
          <Label htmlFor="startDate" className="col-form-label">
            Start Date
          </Label>
          <Input
            id="startDate"
            type="date"
            className="form-control"
            value={fetchedCertificate.startDate}
            disabled
          />
        </Col>
        <Col md={4} className="mb-3">
          <Label htmlFor="endDate" className="col-form-label">
            End Date
          </Label>
          <Input
            id="endDate"
            type="date"
            className="form-control"
            value={fetchedCertificate.endDate}
            disabled
          />
        </Col>
      </>
    );
  };

  const renderMvpGreatWorkFields = () => {
    console.log("Rendering MVP/Great Work fields");
    return (
      <>
        <Col md={4} className="mb-3">
          <Label htmlFor="startDate" className="col-form-label">
            Start Date
          </Label>
          <Input
            id="startDate"
            type="date"
            className="form-control"
            value={fetchedCertificate.startDate}
            disabled
          />
        </Col>
        <Col md={4} className="mb-3">
          <Label htmlFor="endDate" className="col-form-label">
            End Date
          </Label>
          <Input
            id="endDate"
            type="date"
            className="form-control"
            value={fetchedCertificate.endDate}
            disabled
          />
        </Col>
      </>
    );
  };

  const renderPeriodFields = () => {
    console.log("Rendering Period fields");
    return (
      <>
        <Col md={4} className="mb-3">
          <Label htmlFor="startDate" className="col-form-label">
            Start Date
          </Label>
          <Input
            id="startDate"
            type="date"
            className="form-control"
            value={fetchedCertificate.startDate}
            disabled
          />
        </Col>
        <Col md={4} className="mb-3">
          <Label htmlFor="endDate" className="col-form-label">
            End Date
          </Label>
          <Input
            id="endDate"
            type="date"
            className="form-control"
            value={fetchedCertificate.endDate}
            disabled
          />
        </Col>
      </>
    );
  };

  const renderFormFields = () => {
    switch (fetchedCertificate.certificateType) {
      case "internship":
        return renderInternshipFields();
      case "appreciation":
      case "achievement":
        return renderAppreciationAchievementFields();
      case "hackathon_winner":
      case "hackathon_participation":
        return renderHackathonFields();
      case "best_team":
        return renderBestTeamFields();
      case "course_completion":
      case "training_completion":
        return renderCourseTrainingFields();
      case "most_valuable_person":
      case "leaders_choice":
      case "great_work":
        return renderMvpGreatWorkFields();
      case "star_of_the_month":
      case "star_of_the_quarter":
      case "star_performer":
        return renderPeriodFields();
      default:
        return null;
    }
  };

  return (
    <div className="page-content">
      <Container fluid style={{ padding: "0px", gap: "10px" }}>
        <PageSubHeader
          heading={"View Certificate"}
          routePath={"Home"}
          pageName={"Certificates"}
        />
        <Row className="p-4">
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col xs={12} className="card-header">
                    <p className="form-header">Certificate Information</p>
                  </Col>
                  <Row className="justify-content-start">
                    {renderSharedFields()}
                    {renderFormFields()}
                  </Row>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Footer
          saveText="Edit Certificate"
          save={() => navigate(`/add-new-certificates/${certificateId}`)}
          showBackConfirmation={false}
        />
      </Container>
    </div>
  );
}

export default ViewCertificate;